import {BelegDTO} from '../openapi/fakturierung-openapi';
import {DeepPartial} from '../types/deep-partial';
import {BelegLabels} from '../i18n/beleg-labels';


export type Referenzfeld =
  | 'bestellnummer'
  | 'lieferantennummer'
  | 'vertragsnummer'
  | 'projektnummer'
  | 'leitwegId';

export type ReferenzfelderSichtbarkeit = Record<Referenzfeld, boolean>;

export const REFERENZFELDER: Referenzfeld[] = [
  'bestellnummer',
  'lieferantennummer',
  'vertragsnummer',
  'projektnummer',
  'leitwegId',
];

export function referenzfeldLabels(labels: BelegLabels): Record<Referenzfeld, string> {
  return REFERENZFELDER.reduce((acc, feld) => {
    acc[feld] = labels[feld];
    return acc;
  }, {} as Record<Referenzfeld, string>);
}

export const REFERENZFELD_MAX_LENGTH = 255;

export const KEINE_REFERENZFELDER_SICHTBAR: ReferenzfelderSichtbarkeit = {
  bestellnummer: false,
  lieferantennummer: false,
  vertragsnummer: false,
  projektnummer: false,
  leitwegId: false,
};

export function referenzfelderSichtbarkeitAusBeleg(
  beleg?: DeepPartial<BelegDTO>,
): ReferenzfelderSichtbarkeit {
  return REFERENZFELDER.reduce((sichtbarkeit, feld) => {
    sichtbarkeit[feld] = !!beleg?.[feld];
    return sichtbarkeit;
  }, {} as ReferenzfelderSichtbarkeit);
}
